import React from 'react';
import Header from './components/header/header';
import About from './components/about/about';
import Resume from './components/resume/resume';
import Portfolio from './components/portfolio/portfolio';
import Testimonials from './components/testimonials/testimonials';
import Footer from './components/footer/footer';
import resumeData from './resumeData';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Only catch errors that aren't DOM manipulation errors from extensions
    if (error && error.message && error.message.includes('removeChild')) {
      // This is likely extension interference, don't show error boundary
      // Let it fail silently and the periodic check will re-render
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Only log non-DOM errors
    if (!error.message || !error.message.includes('removeChild')) {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{ padding: '20px', textAlign: 'center', color: '#fff', background: '#0f0f0f', minHeight: '100vh' }}>
          <h1>Something went wrong</h1>
          <p>This may be caused by a browser extension interfering with the page.</p>
          <p>Try disabling browser extensions or use incognito mode.</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{ padding: '10px 20px', marginTop: '20px', cursor: 'pointer' }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  // Ensure resumeData is available
  if (!resumeData) {
    console.error('resumeData is not loaded');
    return <div>Error: Resume data not found</div>;
  }

  try {
    return (
      <ErrorBoundary>
        <div className="App">
          <Header resumeData={resumeData} />
          <About resumeData={resumeData} />
          <Portfolio resumeData={resumeData} />
          <Resume resumeData={resumeData} />
          <Testimonials resumeData={resumeData} />
          <Footer resumeData={resumeData} />
        </div>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error('Error rendering App:', error);
    return <div>Error loading application. Please check the console.</div>;
  }
}

export default App;
